import React from "react";
import { motion } from "framer-motion";
import { IntelEntry } from "../../data/intelligence";
import { formatUpdated } from "../../utils/intelligence";
import { ledgerEase } from "../../utils/motion";
type EntryPreviewProps = {
  entry: IntelEntry;
  findEntry: (id: string) => IntelEntry | undefined;
  onSelect: (id: string) => void;
};
export function EntryPreview({
  entry,
  findEntry,
  onSelect
}: EntryPreviewProps) {
  const related = entry.related.map(findEntry).filter((e): e is IntelEntry => Boolean(e));
  return <motion.article key={entry.id} initial={{
    opacity: 0,
    y: 4
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.18,
    ease: ledgerEase
  }} aria-labelledby="entry-title" className="border border-navy bg-ivory" data-id="element-312" data-mp="26nijqpxz8w5e">
      <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1 border-b border-navy px-6 py-4 md:px-8" data-id="element-313" data-mp="1rqrp0tz908m4">
        <p className="eyebrow text-oxblood" data-id="element-314" data-mp="1nqhcszkv4lyt">
          {entry.type}
          {entry.jurisdiction && <span className="text-charcoal/60" data-id="element-315" data-mp="2g3ouy9oxg0hp"> · {entry.jurisdiction}</span>}
        </p>
        <p className="text-[11px] tabular-nums text-charcoal/60" data-id="element-316" data-mp="2kv6viwn1fz25">Updated {formatUpdated(entry.updated)}</p>
      </div>

      <div className="px-6 py-8 md:px-8 md:py-10" data-id="element-317" data-mp="266ttpj19rlzq">
        <h2 id="entry-title" className="font-display text-[clamp(1.75rem,2.8vw,2.5rem)] leading-[1.08] text-navy" data-id="element-318" data-mp="263xyw3kpxdfi">
          {entry.title}
        </h2>
        <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-charcoal/80" data-id="element-319" data-mp="2yvrdjql4pqul">{entry.summary}</p>

        <dl className="mt-8 border-t border-navy" data-id="element-320" data-mp="33s822lw8q787">
          {entry.facts.map(f => <div key={f.label} className="grid grid-cols-1 gap-1 border-b border-stone py-4 sm:grid-cols-5 sm:gap-6" data-id="element-321" data-mp="2psq8lt8025si">
              <dt className="text-sm text-charcoal/65 sm:col-span-2" data-id="element-322" data-mp="2tts8mc9qqlvj">{f.label}</dt>
              <dd className="text-[15px] font-medium leading-relaxed text-navy sm:col-span-3" data-id="element-323" data-mp="1edtfo88p2wfv">{f.value}</dd>
            </div>)}
        </dl>

        {related.length > 0 && <div className="mt-8" data-id="element-324" data-mp="3l34vvw2vymp8">
            <p className="eyebrow text-charcoal/60" data-id="element-325" data-mp="3l23jnoa4vu5x">Related</p>
            <ul className="mt-3" data-id="element-326" data-mp="3g3ij1nqyz8gy">
              {related.map(r => <li key={r.id} data-id="element-327" data-mp="3bd21brg490os">
                  <button type="button" onClick={() => onSelect(r.id)} className="flex w-full items-baseline justify-between gap-4 border-b border-stone py-3 text-left transition-colors duration-150 hover:text-oxblood" data-id="element-328" data-mp="3bc0gwwd7n1ue">
                    <span className="font-display text-lg text-navy" data-id="element-329" data-mp="2xc9614hzq1km">{r.title}</span>
                    <span className="shrink-0 text-[11px] text-charcoal/55" data-id="element-330" data-mp="2sdeene5yj4ow">{r.type}</span>
                  </button>
                </li>)}
            </ul>
          </div>}
      </div>

      <p className="border-t border-stone px-6 py-3 text-[11px] leading-relaxed text-charcoal/55 md:px-8" data-id="element-331" data-mp="qn30e1xhnrvo">
        Summaries for orientation, not legal advice. Full guides include citations and change history.
      </p>
    </motion.article>;
}